const OverrideReportTypes = {
  BUSINESS_ID: 'BUSINESS_ID',
  ENTITY_ID: 'ENTITY_ID',
};

module.exports = {
  OverrideReportTypes,
};
